<template>
  <div class="doctor-detail-page">
    <header class="page-header">
      <div class="container">
        <nav class="breadcrumb">
          <a href="/">首页</a>
          <span>></span>
          <a href="/doctors">专家团队</a>
          <span>></span>
          <span>{{ doctor.name }}</span>
        </nav>
      </div>
    </header>

    <div class="container">
      <div class="doctor-profile">
        <div class="doctor-avatar-large">
          <img :src="doctor.image_url || 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=professional%20female%20doctor%20portrait%20medical%20white%20coat%20hospital&image_size=portrait_4_3'" :alt="doctor.name" />
        </div>
        <div class="doctor-detail-info">
          <h1 class="doctor-name">{{ doctor.name }}</h1>
          <p class="doctor-title">{{ doctor.title }}</p>
          <p class="doctor-department">{{ doctor.department }}</p>
          <div class="info-row">
            <span class="info-label">专业特长:</span>
            <span class="info-value">{{ doctor.specialty }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">简介:</span>
            <span class="info-value">{{ doctor.introduction }}</span>
          </div>
          <button class="consult-btn">预约咨询</button>
        </div>
      </div>

      <div class="section">
        <h2>擅长领域</h2>
        <div class="specialty-tags">
          <span class="tag" v-for="(item, index) in specialtyList" :key="index">{{ item }}</span>
        </div>
      </div>

      <div class="section">
        <h2>学术成就</h2>
        <ul class="achievement-list">
          <li>发表核心期刊论文30余篇</li>
          <li>主持省级科研项目5项</li>
          <li>获得省级科技进步奖2项</li>
          <li>担任多个医学学会委员</li>
        </ul>
      </div>

      <div class="section">
        <h2>出诊时间</h2>
        <table class="schedule-table">
          <thead>
            <tr>
              <th>日期</th>
              <th>上午</th>
              <th>下午</th>
              <th>预约状态</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(day, index) in schedule" :key="index">
              <td>{{ day.date }}</td>
              <td>{{ day.morning }}</td>
              <td>{{ day.afternoon }}</td>
              <td><span :class="day.status === '可预约' ? 'available' : 'unavailable'">{{ day.status }}</span></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'DoctorDetail',
  data() {
    return {
      doctor: {
        id: '',
        name: '',
        title: '',
        department: '',
        specialty: '',
        introduction: '',
        image_url: ''
      },
      specialtyList: [],
      schedule: [
        { date: '周一', morning: '8:00-12:00', afternoon: '14:30-17:30', status: '可预约' },
        { date: '周二', morning: '-', afternoon: '14:30-17:30', status: '可预约' },
        { date: '周三', morning: '8:00-12:00', afternoon: '-', status: '已满' },
        { date: '周四', morning: '8:00-12:00', afternoon: '14:30-17:30', status: '可预约' },
        { date: '周五', morning: '-', afternoon: '14:30-17:30', status: '可预约' },
        { date: '周六', morning: '8:00-12:00', afternoon: '-', status: '可预约' },
        { date: '周日', morning: '-', afternoon: '-', status: '休息' }
      ]
    }
  },
  mounted() {
    const doctorId = this.$route.params.id
    this.fetchDoctor(doctorId)
  },
  methods: {
    async fetchDoctor(id) {
      try {
        const response = await axios.get(`/api/doctor/${id}`)
        const data = response.data.data || response.data
        this.doctor = data
        this.specialtyList = data.specialty ? data.specialty.split('、') : []
      } catch (error) {
        console.error('获取医生信息失败:', error)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.doctor-detail-page {
  min-height: 100vh;
  background: #f5f5f5;
}

.page-header {
  background: white;
  border-bottom: 1px solid #eee;
  padding: 15px 0;

  .breadcrumb {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #666;

    a {
      color: #4ecdc4;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    span {
      margin: 0 8px;
      color: #999;
    }
  }
}

.container {
  max-width: 900px;
  margin: 0 auto;
  padding: 30px 20px;
}

.doctor-profile {
  display: flex;
  gap: 30px;
  background: white;
  border-radius: 15px;
  padding: 30px;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;

  .doctor-avatar-large {
    width: 200px;
    height: 250px;
    border-radius: 10px;
    overflow: hidden;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .doctor-detail-info {
    flex: 1;

    .doctor-name {
      font-size: 28px;
      font-weight: bold;
      color: #333;
      margin-bottom: 10px;
    }

    .doctor-title {
      font-size: 18px;
      color: #4ecdc4;
      margin-bottom: 5px;
    }

    .doctor-department {
      font-size: 14px;
      color: #666;
      margin-bottom: 20px;
    }

    .info-row {
      display: flex;
      margin-bottom: 15px;

      .info-label {
        font-weight: bold;
        color: #333;
        min-width: 80px;
      }

      .info-value {
        color: #666;
        line-height: 1.6;
      }
    }

    .consult-btn {
      background: linear-gradient(135deg, #4ecdc4 0%, #44a08d 100%);
      color: white;
      border: none;
      padding: 12px 30px;
      border-radius: 25px;
      font-size: 16px;
      cursor: pointer;
      margin-top: 20px;

      &:hover {
        opacity: 0.9;
      }
    }
  }
}

.section {
  background: white;
  border-radius: 10px;
  padding: 25px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;

  h2 {
    font-size: 20px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 2px solid #4ecdc4;
  }
}

.specialty-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  .tag {
    background: #f0f8ff;
    color: #4ecdc4;
    padding: 8px 18px;
    border-radius: 20px;
    font-size: 14px;
    border: 1px solid #4ecdc4;
  }
}

.achievement-list {
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    padding: 12px 0;
    padding-left: 25px;
    position: relative;
    color: #666;
    font-size: 14px;
    border-bottom: 1px dashed #eee;

    &:last-child {
      border-bottom: none;
    }

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 8px;
      height: 8px;
      background: #4ecdc4;
      border-radius: 50%;
    }
  }
}

.schedule-table {
  width: 100%;
  border-collapse: collapse;

  th, td {
    padding: 15px;
    text-align: center;
    border-bottom: 1px solid #eee;
    font-size: 14px;
  }

  th {
    background: #f8f9fa;
    font-weight: bold;
    color: #333;
  }

  .available {
    color: #4ecdc4;
    font-weight: bold;
  }

  .unavailable {
    color: #999;
  }
}
</style>
